<template>
    <!-- 循环块 -->
    <div :style="fieldOne.styleSet.kbNameValueBoxStyleSet" name="kbNameValueBoxStyleSet">
      <!-- <el-link  :type="homeSetInfo.penetratePageId > 0?'success':'info'"> -->
      <div @click="toCtPage()" :style="'text-align:center;margin: 5px 0px;'+(fieldOne.styleSet.kbValueStyleSet)" name="kbValueStyleSet" v-loading="loading" >
        {{homeSetvalue}}
        <i v-if="homeSetInfo.penetratePageId > 0" class="el-icon-arrow-right"></i>
      </div>
      <!-- </el-link> -->
      <div :style="'text-align:center;'+(fieldOne.styleSet.kbNameStyleSet)"  name="kbNameStyleSet">{{name}}</div>
    </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_name_value',
  props: {
    mongoId: String,
    roleId: String,
    name:String,
    fieldOne:{
      type:Object,
      default:{}
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(),
      homeSetvalue:null,
      homeSetInfo:{
        penetratePageId:0
      },
      loading:false
    };
  },
  created() {
    var that = this;
    var toHtData = {
        "mongoId" : that.mongoId,
        "roleId" : that.roleId
    };
    var url = "login_getHomeSetData.do";
    that.loading = true;
    //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
    utils.request(that,{
        url: url, //仅为示例，并非真实的接口地址
        data: toHtData,
        success: function (res) {
            var resultMap = res.data;
            that.homeSetInfo = resultMap;
            if((res.data.resultValue+"") != "" && res.data.resultValue >= 0) {
                that.homeSetvalue = res.data.resultValue;
            } else {
                that.homeSetvalue = "无";
            }
            that.loading = false;
        }
    })
  },
  mounted() {
    
  },
  watch:{

  },
  computed:{
  },
  components: {
  },
  methods: {
      toCtPage() {
        var that = this;
        var homeSetInfo = that.homeSetInfo;
        console.log("homeSetInfo===========",homeSetInfo);
        if(homeSetInfo.penetratePageId > 0) {
          //打开新的选项卡页面
          var toListJson = {
            pageId: homeSetInfo.penetratePageId,
            tableId: homeSetInfo.tableId,
            initCheckId: 0,
            callBackType: 0,
            dataMaxNum: 0,
            ctType:3,
            SourceDataId:"public_"+homeSetInfo.attentionInfoId,
            menuId:"home_ct_"+homeSetInfo.attentionInfoId,
            menuName:that.name
          }
          if(that.visitSource == 2) {
            toListJson.openWay = 5;
          }
          pageUtils.toNewListPage(that,toListJson);
          // var appPage = that.$router.app.$children[0];
          // var nowPage = appPage.$children[0];
          // console.log("login-------------------",nowPage);
          // nowPage.addTab(toListJson);
        }
      }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
